/** Raised Date has no fallback: drafts and unverified historical dates are unknown. */
export const formatRequisitionRaisedDate = (requisition: {raisedAt?: string | null}): string =>
  requisition.raisedAt ? requisition.raisedAt.slice(0, 10) : '-'
